import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import TextField from '@mui/material/TextField';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Drawer from '@mui/material/Drawer';

import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import InputBase from '@mui/material/InputBase';
import { alpha } from '@mui/material/styles';

import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import CustomSnackbar from '../components/CustomSnackbar';
import PageHeader from '../components/PageHeader';

import { Navigate, useNavigate } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import AppConfig from '../services/app-config';
import { isMultiTowerEnabled, getTowers, composeUnit, parseTower, validateUnit } from '../services/unit-utils';

import { useSwipeable } from 'react-swipeable';
import { motion, AnimatePresence } from 'framer-motion';

import PersonOffIcon from '@mui/icons-material/PersonOff';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ShareIcon from '@mui/icons-material/Share';
import LockIcon from '@mui/icons-material/Lock';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import GroupsIcon from '@mui/icons-material/Groups';

import AuthService from '../services/auth';
import wsClient from '../services/ws';
import { isReservedTeam } from '../services/systemTeams';

const publicUrl = process.env.REACT_APP_PUBLIC_URL;

export default function UsersAdmin({setNavbarState, navbarState, window}) {
  const [users, setUsers] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [tabValue, setTabValue] = React.useState('activo');
  const [offset, setOffset] = React.useState(0);
  const [hasMore, setHasMore] = React.useState(false);
  const [loadingMore, setLoadingMore] = React.useState(false);
  const sentinelRef = React.useRef(null);
  const PAGE_SIZE = 20;
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' }); 
  const navigate = useNavigate();
  const [connectedUsers, setConnectedUsers] = React.useState(0);
  const [newUserName, setNewUserName] = React.useState('');
  const [newUserLastName, setNewUserLastName] = React.useState('');
  const [newUserMode, setNewUserMode] = React.useState('pro');
  const [newUnitMode, setNewUnitMode] = React.useState('propia');
  const [newUserUnit, setNewUserUnit] = React.useState('');
  const [newUserUnitValid,setNewUserUnitValid] = React.useState({"error": false, "message": ""});
  const [newUserTower, setNewUserTower] = React.useState('');
  const [newUserApt, setNewUserApt] = React.useState('');
  const [newUserRole, setNewUserRole] = React.useState('habitante');
  const [newUserPhone, setNewUserPhone] = React.useState('');
  const [newUserEmail, setNewUserEmail] = React.useState('');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [drawerShow, setDrawerShow] = React.useState(false);
  const [sendInvite, setSendInvite] = React.useState(true);
  const [deleteUserDialog, setDeleteUserDialog] = React.useState(false);
  const [pwdResetDialog, setPwdResetDialog] = React.useState(false);
  const [userToDelete, setUserToDelete] = React.useState(null);
  const [userToReset, setUserToReset] = React.useState(null);
  const [modules, setModules] = React.useState({});
  const [showUnitMode, setShowUnitMode] = React.useState(false);
  const [drawerCTA, setDrawerCTA] = React.useState('Agregar');
  const [swipeDirection, setSwipeDirection] = React.useState(null);
  const [moreOptsDrawer, setMoreOptsDrawer] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [pendingMenuAnchorEl, setPendingMenuAnchorEl] = React.useState(null);
  const [pendingMenuUser, setPendingMenuUser] = React.useState(null);
  const [resendingInvcode, setResendingInvcode] = React.useState(null);
  const [accessRestrictModal, setAccessRestrictModal] = React.useState(false);
  const [selectedModules, setSelectedModules] = React.useState({});
  // Teams (Feature 1) — only relevant for admin-role users.
  const [teams, setTeams] = React.useState({});
  const [newUserTeam, setNewUserTeam] = React.useState([]);
  const [manageTeamsOpen, setManageTeamsOpen] = React.useState(false);
  const [teamFormKey, setTeamFormKey] = React.useState('');
  const [teamFormNombre, setTeamFormNombre] = React.useState('');
  const [teamFormDescripcion, setTeamFormDescripcion] = React.useState('');
  const [teamFormError, setTeamFormError] = React.useState('');
  const [teamDeleteError, setTeamDeleteError] = React.useState('');

  
  const filteredUsers = users.filter(user => {
    const q = String(searchValue || '').toLowerCase();
    const name = String(user?.name || '').toLowerCase();
    const lastname = String(user?.lastname || '').toLowerCase();
    const phone = String(user?.phone || '').toLowerCase();
    const unit = String(user?.unit || '').toLowerCase();
    const role = String(user?.role || '').toLowerCase();
    const username = String(user?.username || '').toLowerCase();

    return (
      name.includes(q)
      || lastname.includes(q)
      || phone.includes(q)
      || unit.includes(q)
      || role.includes(q)
      || username.includes(q)
    );
  });

  const getInitials = React.useCallback((user) => {
    const first = (user?.name || '').trim().charAt(0);
    const last = (user?.lastname || '').trim().charAt(0);
    const initials = `${first}${last}`.toUpperCase();
    return initials || 'U';
  }, []);

  const getRoleLabel = React.useCallback((role) => {
    const r = String(role || '').toLowerCase();
    if (r === 'admin') return 'Admin';
    if (r === 'receptor') return 'Receptor';
    if (r === 'habitante') return 'Residente';
    return role || '—';
  }, []);

  const getRoleChipSx = React.useCallback((role) => {
    const r = String(role || '').toLowerCase();

    if (r === 'habitante') {
      return {
        bgcolor: (theme) => alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.25 : 0.12),
        color: (theme) => theme.palette.success.main,
      };
    }

    if (r === 'admin' || r === 'receptor') {
      return {
        bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.35 : 0.12),
        color: (theme) => (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main),
      };
    }

    return {
      bgcolor: (theme) => alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.18 : 0.06),
      color: 'text.secondary',
    };
  }, []);

  const fabStyle = {
    position: 'fixed',
    bottom: 96,
    right: 20,
  };

  const handleDrawerToggle = () => {
    setDrawerShow((prevState) => !prevState);
    if (!drawerShow) {
      resetDrawer();
    }
  };

  const roleDict = {
    "Habitante": "habitante",
    "Receptor": "receptor",
    "Admin": "admin"
  }

  var regex = null
  if (AppConfig.getLocal("unit_regex")) {
    regex = new RegExp(AppConfig.getLocal("unit_regex"));
  }

  const handleModeChange = (value) => {
    setNewUserMode(value);
    if (value === "inq") {
      setNewUnitMode("rentada");
    }
  }

  const handleUnitChange = (event) => {
    const value = event.target.value;
    if (isMultiTowerEnabled() && newUserRole === 'habitante') {
      // Free-text path is unused when multi-tower is enabled (tower select + apt field),
      // but keep validation consistent if this is ever called.
      const result = validateUnit(value, regex ? AppConfig.getLocal("unit_regex") : null);
      setNewUserUnitValid({"error": result.valid ? false : true, "message": result.error});
      if (result.valid) {
        const tower = parseTower(value);
        if (tower) setNewUserTower(tower);
      }
    } else if (AppConfig.getLocal("unit_regex") && newUserRole === 'habitante') {
      var text = value;
      if (AppConfig.getLocal("unit_sample")) {
        var complement_length = Math.max(0, AppConfig.getLocal("unit_sample").length - text.length);
        var complement_text = AppConfig.getLocal("unit_sample").slice(-complement_length);
        if (complement_length === 0) {
          complement_text = "" ;
          setShowUnitMode(true);
        }
        text = `${text}${complement_text}`
      }
      if (!regex.test(text)) {
        setNewUserUnitValid({"error": true, "message": `Formato Incorrecto ej. ${AppConfig.getLocal("unit_sample")}`});
        setShowUnitMode(false);
      } else {
        setNewUserUnitValid({"error": false, "message": ""});
      }
    }
    setNewUserUnit(value);
  }

  const handleTowerChange = (tower) => {
    setNewUserTower(tower);
    const composed = composeUnit(tower, newUserApt);
    setNewUserUnit(composed);
    if (composed) {
      const result = validateUnit(composed, regex ? AppConfig.getLocal("unit_regex") : null);
      setNewUserUnitValid({"error": result.valid ? false : true, "message": result.valid ? "" : result.error});
      if (result.valid) setShowUnitMode(true); else setShowUnitMode(false);
    } else {
      setNewUserUnitValid({"error": false, "message": ""});
    }
  }

  const handleAptChange = (apt) => {
    setNewUserApt(apt);
    const composed = composeUnit(newUserTower, apt);
    setNewUserUnit(composed);
    if (composed) {
      const result = validateUnit(composed, regex ? AppConfig.getLocal("unit_regex") : null);
      setNewUserUnitValid({"error": result.valid ? false : true, "message": result.valid ? "" : result.error});
      if (result.valid) setShowUnitMode(true); else setShowUnitMode(false);
    } else {
      setNewUserUnitValid({"error": false, "message": ""});
    }
  }

  const handleNewUser = () => {
    setNewUserName("");
    setNewUserLastName("");
    setNewUserPhone("");
    setNewUserEmail("");
    setNewUserRole("habitante");
    setNewUserUnit("");
    setNewUserTower("");
    setNewUserApt("");
    setNewUserTeam([]);
    setDrawerCTA('Agregar');
    setSendInvite(true);
    setDrawerShow(true);
    setNewUserMode('pro');
    setNewUnitMode('propia');
    setShowUnitMode(false);
    fetchTeams();
  }

  const handleEditUser = (username) => {
    const user = users.find(user => user.username === username);
    setNewUserName(user.name);
    setNewUserLastName(user.lastname);
    setNewUserPhone(user.phone);
    setNewUserEmail(user.username);
    setNewUnitMode(user.unit_data.mode);
    setNewUserRole(roleDict[user.role]);
    setNewUserUnit(user.unit);
    setNewUserTower(isMultiTowerEnabled() ? parseTower(user.unit) || '' : '');
    setNewUserApt(isMultiTowerEnabled() && user.unit && user.unit.includes('-') ? user.unit.split('-').slice(1).join('-') : '');
    setNewUserTeam(Array.isArray(user?.team) ? user.team : (user?.team ? [user.team] : []));
    setDrawerCTA('Editar');
    setSendInvite(false);
    setDrawerShow(true);
    setNewUserMode(user.mode);
    setShowUnitMode(true);
    fetchTeams();
  }

  const fetchUsers = (type='activo') => {
    setLoading(true);
    setOffset(PAGE_SIZE);
    if (type === "activo"){
        apiClient.get(`users/allusersadmin?limit=${PAGE_SIZE}&offset=0`, {}, { action: 'fetch_all_users_admin' })
         .then((response) => {
           if (response.status === 200) {
             const data = response.data.data || {};
             setUsers(data.items || []);
             setHasMore(data.hasMore || false);
             setLoading(false)
           }
         })
         .catch(error => {
           console.error(error);
           if (error.response.data.code === 401) {
              setRedirect({ trigger: true, route: '/login' })
            }
         })} else {
        apiClient.get(`users/allinvitedadmin?limit=${PAGE_SIZE}&offset=0`, {}, { action: 'fetch_all_invited_admin' })
        .then((response) => {
            if (response.status === 200) {
            const data = response.data.data || {};
            setUsers(data.items || []);
            setHasMore(data.hasMore || false);
            setLoading(false)
            }
        })
        .catch(error => {
            console.error(error);
            if (error.response.data.code === 401) {
              setRedirect({ trigger: true, route: '/login' })
            }
        })

         }
  }

  const loadMore = () => {
    if (loadingMore || !hasMore) return;
    setLoadingMore(true);
    const currentOffset = offset;
    const endpoint = tabValue === 'activo' ? 'users/allusersadmin' : 'users/allinvitedadmin';
    apiClient.get(`${endpoint}?limit=${PAGE_SIZE}&offset=${currentOffset}`, {}, { action: 'fetch_users_more' })
      .then((response) => {
        if (response.status === 200) {
          const data = response.data.data || {};
          const newItems = data.items || [];
          setUsers(prev => [...prev, ...newItems]);
          setOffset(currentOffset + PAGE_SIZE);
          setHasMore(data.hasMore || false);
        }
        setLoadingMore(false);
      })
      .catch((error) => {
        console.error('Error loading more users:', error);
        setLoadingMore(false);
      });
  };

  React.useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore && !loadingMore && !loading) {
        loadMore();
      }
    }, { rootMargin: '100px' });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, loadingMore, loading, tabValue, offset]);

  const fetchAvailableModules = () => {
    apiClient.get('modules/available', {}, { action: 'fetch_available_modules' })
      .then((response) => {
        if (response.status === 200) {
          setModules(response.data.data)
        }
      })
  }

  const fetchTeams = React.useCallback(() => {
    apiClient.get('teams', {}, { action: 'fetch_teams' })
      .then((response) => {
        if (response.status === 200 && response.data?.data) {
          setTeams(response.data.data.teams || {});
        }
      })
      .catch((err) => {
        if (shouldRedirectToLogin(err)) {
          setRedirect({ trigger: true, route: '/login' });
        }
      });
  }, []);

  const teamNombre = React.useCallback((key) => {
    if (!key) return '';
    const t = teams[key];
    return t?.nombre || key;
  }, [teams]);

  const createNewUser = () => {
    var localNewUserUnit;
    if(!['habitante', 'receptor', 'admin'].includes(newUserRole)){
      setSnackbarSeverity("warning")
      setSnackbarMessage('El rol solo puede ser admin, receptor o habitante');
      setSnackbarOpen(true);
      return;
    }
    if (newUserName === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el nombre del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserLastName === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el apellido del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserPhone === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el numero de telefono del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserEmail === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el correo del usuario.');
      setSnackbarOpen(true);
      return;
    }
    if (newUserRole === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el nombre del usuario.');
      setSnackbarOpen(true);
    } else if (newUserRole === 'receptor')  {
      localNewUserUnit = 'Recepcion'
    } else if (newUserRole === 'admin')  {
      localNewUserUnit = 'Administracion'
    } else if (newUserRole === 'habitante')  {
      localNewUserUnit = newUserUnit
    }

    if (localNewUserUnit === ""){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa el la unidad del usuario.');
      setSnackbarOpen(true);
      return;
    }

    if (newUserMode === "" || newUserMode === "ninguna" && newUserRole === 'habitante'){
      setSnackbarSeverity("warning")
      setSnackbarMessage('Porfavor ingresa la modalidad del usuario.');
      setSnackbarOpen(true);
      return;
    }

    if (isMultiTowerEnabled() && newUserRole === 'habitante') {
      const result = validateUnit(localNewUserUnit, regex ? AppConfig.getLocal("unit_regex") : null);
      if (!result.valid) {
        setSnackbarSeverity("warning")
        setSnackbarMessage(result.error || `La unidad no cumple con el formato esperado de apartamentos, ej. ${AppConfig.getLocal("unit_sample")}`);
        setSnackbarOpen(true);
        return;
      }
    } else if (AppConfig.getLocal("unit_regex") && newUserRole === 'habitante') {
      if (!regex.test(localNewUserUnit)) {
        setSnackbarSeverity("warning")
        setSnackbarMessage(`La unidad no cumple con el formato esperado de apartamentos, ej. ${AppConfig.getLocal("unit_sample")}`);
        setSnackbarOpen(true);
        return;
      }
    }

    const data = {
      name: newUserName,
      lastname: newUserLastName,
      unit: localNewUserUnit,
      role: newUserRole,
      phone: newUserPhone,
      email: newUserEmail,
      sendMail: sendInvite,
      action: drawerCTA.toLowerCase(),
      mode: newUserMode,
      unitMode: newUnitMode
    }
    if (newUserRole === 'admin') {
      data.team = Array.isArray(newUserTeam) ? newUserTeam : [];
    }

    apiClient.post('invite/user', data, {}, { action: 'invite_user' })
      .then((response) => {
        if (response.status === 200) {
          setSnackbarSeverity("success")
          if (drawerCTA === "Agregar"){
            setSnackbarMessage('Usuario creado exitosamente.');
            setTabValue('invitado');
            fetchUsers('invitado');
          } else if (drawerCTA === "Editar"){
            setSnackbarMessage('Usuario editado exitosamente.');
            setTabValue('activo');
            fetchUsers('activo');
          }
          setDrawerShow(false);
          setSnackbarOpen(true);
        }
      })
      .catch((err) => {
        if (err.response?.data?.code === 409) {
          setSnackbarSeverity("error")
          setSnackbarMessage('El usuario ya existe en la base de datos.');
          setSnackbarOpen(true);
        } else {
        console.error(err);
        setSnackbarSeverity("error")
        setSnackbarMessage('Tuvimos un error intenta de nuevo en otro momento.');
        setSnackbarOpen(true);}
      });
  };

  const handleSendInviteSwitch = (event) => {
    setSendInvite(event.target.checked);
  };

  const resetDrawer = () => {
    setNewUserName("");
    setNewUserLastName("");
    setNewUserPhone("");
    setNewUserEmail("");
    setNewUserRole("habitante");
    setNewUserUnit("");
    setNewUserTower("");
    setNewUserApt("");
    setNewUserTeam([]);
    setNewUserMode('pro');
    setNewUnitMode('propia');
    setShowUnitMode(false);
  };

  const newUserDrawer = (
    <Box
      sx={{
        width: '100%',
        height: { xs: '100dvh', sm: '100vh' },
        bgcolor: 'background.default',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ px: 2.5, pt: 2.25, pb: 1.5 }}>
        <PageHeader
          title={drawerCTA === 'Agregar' ? 'Nuevo Usuario' : 'Editar Usuario'}
          icon="user-plus"
          onBack={() => { handleDrawerToggle(); }}
          titleSx={{ fontSize: 22, fontWeight: 900 }}
        />
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', px: 3, pb: 2 }}>
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 900, color: 'text.primary' }}>
            Datos Personales
          </Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary', mt: 0.5 }}>
            Por favor, ingrese la información básica del usuario.
          </Typography>
        </Box>

        <>
            <TextField
              fullWidth
              value={newUserName}
              id="name"
              label="Nombre"
              variant="outlined"
              onChange={(e) => setNewUserName(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />
            <TextField
              fullWidth
              value={newUserLastName}
              id="lastname"
              label="Apellido"
              variant="outlined"
              onChange={(e) => setNewUserLastName(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />
            <TextField
              fullWidth
              value={newUserEmail}
              id="email"
              label="Correo Electrónico"
              variant="outlined"
              disabled={drawerCTA === 'Editar'}
              onChange={(e) => setNewUserEmail(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />
            <TextField
              fullWidth
              value={newUserPhone}
              id="phone"
              label="Teléfono"
              variant="outlined"
              onChange={(e) => setNewUserPhone(e.target.value)}
              sx={{ mb: 2 }}
              inputProps={{ style: { height: 24 } }}
            />

            <FormControl sx={{ mb: 2 }} fullWidth>
              <InputLabel id="role-select-label">Rol</InputLabel>
              <Select
                labelId="role-select-label"
                id="role-select"
                value={newUserRole}
                label="Rol"
                onChange={(e) => setNewUserRole(e.target.value)}
              >
                <MenuItem value="habitante">Habitante</MenuItem>
                <MenuItem value="receptor">Receptor</MenuItem>
                <MenuItem value="admin">Administrador</MenuItem>
              </Select>
            </FormControl>

            {newUserRole === 'admin' && (
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <FormControl sx={{ flex: 1 }} fullWidth>
                    <InputLabel id="team-select-label">Equipo</InputLabel>
                    <Select
                      labelId="team-select-label"
                      id="team-select"
                      multiple
                      value={newUserTeam}
                      label="Equipo"
                      onChange={(e) => setNewUserTeam(e.target.value)}
                      renderValue={(selected) => (Array.isArray(selected) ? selected.map(teamNombre).join(', ') : '')}
                    >
                      {Object.entries(teams).filter(([key]) => !isReservedTeam(key)).map(([key, t]) => (
                        <MenuItem key={key} value={key}>{t?.nombre || key}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => openManageTeams()}
                    startIcon={<GroupsIcon />}
                    sx={{ textTransform: 'none', fontWeight: 800, whiteSpace: 'nowrap' }}
                  >
                    Gestionar
                  </Button>
                </Box>
                <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                  Asigna un equipo al administrador o crea/edita equipos.
                </Typography>
              </Box>
            )}

            {drawerCTA === 'Agregar' && (
              <FormGroup sx={{ mb: 1 }}>
                <FormControlLabel
                  control={<Switch onChange={handleSendInviteSwitch} checked={sendInvite} />}
                  label="Enviar Correo de Invitación"
                />
              </FormGroup>
            )}
        </>

        {newUserRole === 'habitante' && (
          <>
            <Box sx={{ mt: 2.5, mb: 2 }}>
              <Typography sx={{ fontSize: 18, fontWeight: 900, color: 'text.primary' }}>
                Unidad
              </Typography>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary', mt: 0.5 }}>
                Agregue la información de unidad y modalidad.
              </Typography>
            </Box>

            {isMultiTowerEnabled() ? (
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                  <FormControl sx={{ flex: '0 0 120px' }}>
                    <InputLabel id="tower-select-label">Torre</InputLabel>
                    <Select
                      labelId="tower-select-label"
                      id="tower-select"
                      value={newUserTower}
                      label="Torre"
                      onChange={(e) => handleTowerChange(e.target.value)}
                    >
                      <MenuItem value="" disabled>Seleccione</MenuItem>
                      {getTowers().map((t) => (
                        <MenuItem key={t} value={t}>{t}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    value={newUserApt}
                    id="apt"
                    label="Apartamento"
                    variant="outlined"
                    onChange={(e) => handleAptChange(e.target.value)}
                    inputProps={{ style: { height: 24 } }}
                  />
                </Box>
                <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                  Unidad: <strong>{newUserUnit || `${newUserTower || '—'}-…`}</strong>
                </Typography>
                {newUserUnitValid.message && (
                  <Typography sx={{ fontSize: 12, color: newUserUnitValid.error ? 'error.main' : 'text.secondary', mt: 0.5 }}>
                    {newUserUnitValid.message}
                  </Typography>
                )}
              </Box>
            ) : (
              <TextField
                fullWidth
                value={newUserUnit}
                id="unit"
                label={AppConfig.get('unit_type')}
                variant="outlined"
                onChange={(e) => handleUnitChange(e)}
                helperText={newUserUnitValid.message}
                error={newUserUnitValid.error}
                sx={{ mb: 2 }}
                inputProps={{ style: { height: 24 } }}
              />
            )}

            <FormControl sx={{ mb: 2 }} fullWidth>
              <InputLabel id="mode-select-label">Modalidad</InputLabel>
              <Select
                labelId="mode-select-label"
                id="mode-select"
                value={newUserMode}
                label="Modalidad"
                onChange={(e) => handleModeChange(e.target.value)}
              >
                <MenuItem value="pro">Propietario</MenuItem>
                <MenuItem value="inq">Inquilino</MenuItem>
                {drawerCTA !== 'Agregar' && <MenuItem value="ninguna">Sin Configurar</MenuItem>}
              </Select>
            </FormControl>

            {showUnitMode && (
              <FormControl sx={{ mb: 2 }} fullWidth>
                <InputLabel id="unit-usage-label" shrink>{`Uso de ${newUserUnit}`}</InputLabel>
                <Select
                  labelId="unit-usage-label"
                  id="unit-usage-select"
                  value={newUnitMode}
                  label={`Uso de ${newUserUnit}`}
                  onChange={(e) => setNewUnitMode(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="ninguna" disabled>Seleccione una opción</MenuItem>
                  <MenuItem value="rentada">En Renta</MenuItem>
                  <MenuItem value="propia" disabled={newUserMode === 'inq'}>Uso Propio</MenuItem>
                  <MenuItem value="airbnb" disabled={newUserMode === 'inq'}>AirBnb</MenuItem>
                </Select>
              </FormControl>
            )}
          </>
        )}
      </Box>

      <Box sx={{ p: 3, borderTop: '1px solid', borderColor: (theme) => alpha(theme.palette.divider, 0.5) }}>
        <Button
          fullWidth
          size="large"
          variant="contained"
          color="secondary"
          onClick={() => {
            createNewUser();
          }}
          sx={(theme) => ({
            py: 1.5,
            borderRadius: '10px',
            fontWeight: 900,
            textTransform: 'none',
            bgcolor: theme.palette.success.main,
            color: theme.palette.getContrastText(theme.palette.success.main),
            '&:hover': { bgcolor: theme.palette.success.dark },
          })}
        >
          {drawerCTA}
        </Button>
      </Box>
    </Box>
  );

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (tabValue === 'activo') {
        setSwipeDirection('left');
        setTabValue('invitado');
        setOffset(0);
        setHasMore(false);
        fetchUsers('invitado');
      }
    },
    onSwipedRight: () => {
      if (tabValue === 'invitado') {
        setSwipeDirection('right');
        setTabValue('activo');
        setOffset(0);
        setHasMore(false);
        fetchUsers('activo');
      }
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const pageVariants = {
    enter: (direction) => {
      return {
        x: direction === 'left' ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        x: direction === 'left' ? -1000 : 1000,
        opacity: 0
      };
    }
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5
  };

  React.useEffect(() => {
    fetchUsers(tabValue)
    fetchAvailableModules()
    fetchTeams()
    setNavbarState({...navbarState, showBack: true, showOptions: false, showSearch: false})
  }, [])

  React.useEffect(() => {
    const currentOrg = AuthService.getCurrentUserOrg?.() || '';

    apiClient.get('admin/status', {}, { action: 'fetch_admin_status_users_admin' })
      .then((response) => {
        const connections = response?.data?.data?.connections ?? response?.data?.data?.connected_users;
        if (typeof connections === 'number') {
          setConnectedUsers(connections);
        }
      })
      .catch(() => {
        // ignore
      });

    if (!currentOrg) {
      return undefined;
    }

    const offConnectedUsers = wsClient.on('connected_users', (msg) => {
      const eventOrg = msg?.data?.org;
      const connections = msg?.data?.connections;

      if (!eventOrg || eventOrg.toLowerCase() !== String(currentOrg).toLowerCase()) {
        return;
      }

      if (typeof connections === 'number') {
        setConnectedUsers(connections);
      }
    });

    return () => {
      if (typeof offConnectedUsers === 'function') {
        offConnectedUsers();
      }
    };
  }, []);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const closeDeleteUserDialog = () => {
    setDeleteUserDialog(false);
  }

  const showDeleteUserDialog = (user) => {
    user['user_id'] = user.invcode ? user.invcode : user.username;
    setUserToDelete(user);
    setDeleteUserDialog(true);
  }

  const showPwdResetDialog = (user) => {
    setUserToReset(user);
    setPwdResetDialog(true);
  }

  const closePwdResetDialog = () => {
    setPwdResetDialog(false);
  }
  
  
  const deleteUser = (userId) => {
    setLoading(true)
    setDeleteUserDialog(false);
    apiClient.post('delete/user', {"id": userId}, {}, { action: 'delete_user' })
      .then((response) => {
        if (response.status === 200) {
          setSnackbarSeverity("success")
          setSnackbarMessage('Usuario eliminado.');
          fetchUsers(tabValue);          
          setSnackbarOpen(true);
          setLoading(false)
          setMoreOptsDrawer(false);
          setSelectedUser(null);
        }
      })
      .catch((err) => {
        console.error(err);
        setSnackbarSeverity("error")
        setSnackbarMessage('Tuvimos un error intenta de nuevo en otro momento.');
        setSnackbarOpen(true);
      });
  };

  const resetPwd = (email) => {
    if (!email) {
      setSnackbarSeverity('warning');
      setSnackbarMessage('Correo inválido');
      setSnackbarOpen(true);
      setPwdResetDialog(false);
      return;
    }

    setLoading(true);
    setPwdResetDialog(false);
    apiClient.post('request/reset/login', { email }, {}, { action: 'request_reset_login' })
      .then((response) => {
        AppConfig.parseResponse(response);
        if (response.status === 200) {
          setSnackbarSeverity('success');
          setSnackbarMessage('Correo de restablecimiento enviado.');
          setSnackbarOpen(true);
        }
      })
      .catch((err) => {
        if (shouldRedirectToLogin(err)) {
          setRedirect({ trigger: true, route: '/login' });
          return;
        }
        setSnackbarSeverity('error');
        setSnackbarMessage(getErrorMessage(err) || 'Error al enviar el correo de restablecimiento.');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const shareInvite = (invcode) => {
    const inviteUrl = `${publicUrl}/registro?invcode=${invcode}`;
    if (navigator.share) {
      navigator.share({
         title: 'Registrate en MiGarita.Online',
         url: inviteUrl
      }).then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(inviteUrl)
        .then(() => {
          setSnackbarSeverity('success');
          setSnackbarMessage('Enlace copiado al portapapeles');
          setSnackbarOpen(true);
        })
        .catch((error) => {
          console.log('Error copying invite link', error);
          setSnackbarSeverity('error');
          setSnackbarMessage('No se pudo copiar el enlace.');
          setSnackbarOpen(true);
        });
    } else {
      setSnackbarSeverity('info');
      setSnackbarMessage(`Enlace de invitación: ${inviteUrl}`);
      setSnackbarOpen(true);
    }
  }

  const resendInvite = (invcode) => {
    if (!invcode || resendingInvcode) return;
    setResendingInvcode(invcode)
    apiClient.post('invite/resend', {"invite_code": invcode}, {}, { action: 'resend_invite' })
      .then((response) => {
        if (response.status === 200) {
          setSnackbarSeverity("success")
          setSnackbarMessage('Correo de invitacion enviado.');
          setSnackbarOpen(true);
        }
      })
      .catch((err) => {
        console.error(err);
        setSnackbarSeverity("error")
        setSnackbarMessage('Tuvimos un error intenta de nuevo en otro momento.');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setResendingInvcode(null);
      });
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setOffset(0);
    setHasMore(false);
    setLoading(true)
    fetchUsers(newValue);
  };

  const handleMoreOptions = (user) => {
    setSelectedUser(user);
    setMoreOptsDrawer(true);
  };

  const handlePendingMenuOpen = (event, user) => {
    setPendingMenuAnchorEl(event.currentTarget);
    setPendingMenuUser(user);
  };

  const handlePendingMenuClose = () => {
    setPendingMenuAnchorEl(null);
    setPendingMenuUser(null);
  };

  const handlePendingMenuResend = () => {
    const user = pendingMenuUser;
    handlePendingMenuClose();
    if (user?.invcode) resendInvite(user.invcode);
  };

  const handlePendingMenuDelete = () => {
    const user = pendingMenuUser;
    handlePendingMenuClose();
    if (user) showDeleteUserDialog(user);
  };

  const handleCloseMoreOpts = () => {
    setMoreOptsDrawer(false);
    setSelectedUser(null);
  };

  const handleModuleChange = (event) => {
    setSelectedModules({
      ...selectedModules,
      [event.target.name]: event.target.checked,
    });
  };

  const openAccessRestrictModal = (user) => {
    let modulesToRestrict = {}
    // Check if user.restricted_modules is an array
    if (Array.isArray(user.restricted_modules)) {
      // If it's an array, set each module to true
      user.restricted_modules.forEach(module => {
        modulesToRestrict[module] = true;
      });
    } else if (typeof user.restricted_modules === 'object') {
      // If it's already an object, use it directly
      modulesToRestrict = { ...user.restricted_modules };
    }
    
    setSelectedUser(user);
    setSelectedModules(modulesToRestrict);
    setAccessRestrictModal(true);
  };

  const closeAccessRestrictModal = () => {
    setAccessRestrictModal(false);
    setSelectedUser(null);
  };

  const saveAccessRestrictions = () => {
    console.log('Saving access restrictions for user:', selectedUser);
    console.log('Restricted modules:', selectedModules);
    apiClient.post('modules/restrict', {
      "username": selectedUser.username,
      "modules": selectedModules
    }, {}, { action: 'restrict_modules' })
    .then((response) => {
      AppConfig.parseResponse(response);
      if (response.status === 200) {
        setSnackbarSeverity("success");
        setSnackbarMessage('Accesos actualizados exitosamente.');
        setSnackbarOpen(true);
        closeAccessRestrictModal();
        setMoreOptsDrawer(false);
        fetchUsers(tabValue);
      }
    })
    .catch((err) => {
      console.error(err);
      setSnackbarSeverity("error");
      setSnackbarMessage('Error al actualizar los accesos.');
      setSnackbarOpen(true);
    });
  };

  // --- Teams management (Feature 1) ---
  const resetTeamForm = () => {
    setTeamFormKey('');
    setTeamFormNombre('');
    setTeamFormDescripcion('');
    setTeamFormError('');
  };

  const openManageTeams = () => {
    setTeamDeleteError('');
    resetTeamForm();
    fetchTeams();
    setManageTeamsOpen(true);
  };

  const closeManageTeams = () => {
    setManageTeamsOpen(false);
    resetTeamForm();
    setTeamDeleteError('');
  };

  const startEditTeam = (key, team) => {
    setTeamFormKey(key);
    setTeamFormNombre(team?.nombre || '');
    setTeamFormDescripcion(team?.descripcion || '');
    setTeamFormError('');
    setTeamDeleteError('');
  };

  const submitTeamForm = () => {
    setTeamFormError('');
    const nombre = (teamFormNombre || '').trim();
    if (!nombre) {
      setTeamFormError('El nombre del equipo es obligatorio.');
      return;
    }
    const descripcion = (teamFormDescripcion || '').trim();
    if (teamFormKey) {
      // Edit existing team.
      apiClient.post('teams/update', { key: teamFormKey, nombre, descripcion }, {}, { action: 'update_team' })
        .then((response) => {
          if (response.status === 200) {
            setTeams(response.data?.data?.teams || {});
            setSnackbarSeverity('success');
            setSnackbarMessage('Equipo actualizado.');
            setSnackbarOpen(true);
            resetTeamForm();
          }
        })
        .catch((err) => {
          setTeamFormError(getErrorMessage(err, 'Error al actualizar el equipo.'));
        });
    } else {
      // Create new team — derive the key from the nombre if not provided.
      const key = (teamFormKey || '').trim() || String(nombre).toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      apiClient.post('teams', { key, nombre, descripcion }, {}, { action: 'create_team' })
        .then((response) => {
          if (response.status === 200) {
            setTeams(response.data?.data?.teams || {});
            setSnackbarSeverity('success');
            setSnackbarMessage('Equipo creado.');
            setSnackbarOpen(true);
            resetTeamForm();
          }
        })
        .catch((err) => {
          setTeamFormError(getErrorMessage(err, 'Error al crear el equipo.'));
        });
    }
  };

  const deleteTeam = (key) => {
    setTeamDeleteError('');
    apiClient.post('teams/delete', { key }, {}, { action: 'delete_team' })
      .then((response) => {
        if (response.status === 200) {
          setTeams(response.data?.data?.teams || {});
          setSnackbarSeverity('success');
          setSnackbarMessage('Equipo eliminado.');
          setSnackbarOpen(true);
          if (teamFormKey === key) {
            resetTeamForm();
          }
        }
      })
      .catch((err) => {
        // apiClient throws ApiError, which exposes the raw axios payload as
        // err.data (=== error.response.data) and the original error as
        // err.originalError. The backend response body shape is
        // { code, msg, data: { error, blocking_users } }, so the team_in_use
        // marker and blocking_users live under the inner `data` key. Support
        // both the nested and flat shapes for robustness.
        const body = err?.data || err?.originalError?.response?.data || err?.response?.data || {};
        const inner = body?.data || {};
        const payload = (inner?.error === 'team_in_use') ? inner : body;
        const status = err?.statusCode || err?.originalError?.response?.status || err?.response?.status;
        if (status === 409 && payload?.error === 'team_in_use' && Array.isArray(payload?.blocking_users)) {
          const list = payload.blocking_users
            .map((u) => `${(u.name || '').trim()} ${(u.lastname || '').trim()}`.trim())
            .filter((n) => n.length > 0)
            .map((n, i) => {
              const email = (payload.blocking_users[i].email || '').trim();
              return email ? `${n} (${email})` : n;
            })
            .join(', ');
          setTeamDeleteError(
            list
              ? `El equipo está asignado a los siguientes administradores: ${list}.`
              : 'El equipo está asignado a uno o más administradores.'
          );
        } else {
          setTeamDeleteError(getErrorMessage(err, 'Error al eliminar el equipo.'));
        }
      });
  };

  const moreOptsDrawerContent = (
    <Card
    sx={{ 
      py: 3, 
      px: 2, 
      display: 'block', 
      marginLeft: 'auto', 
      marginRight: 'auto', 
      borderTopLeftRadius: "20px", 
      borderTopRightRadius: "20px", 
      borderBottomRightRadius: "0px", 
      borderBottomLeftRadius: "0px", 
      maxWidth: "550px",
      width: '100%' 
    }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" sx={{ mb: 2 }}>
          Mas Opciones para {selectedUser ? `${selectedUser.name} ${selectedUser.lastname}` : ''}
        </Typography>
        <List>
          <ListItem button onClick={() => openAccessRestrictModal(selectedUser)}>
            <ListItemIcon>
              <LockIcon />
            </ListItemIcon>
            <ListItemText primary="Restringir Accesos" />
          </ListItem>
          {/* <ListItem button onClick={() => showPwdResetDialog(selectedUser)}>
            <ListItemIcon>
              <KeyIcon />
            </ListItemIcon>
            <ListItemText primary="Reiniciar Contraseña" />
          </ListItem> */}
          <ListItem button onClick={() => showDeleteUserDialog(selectedUser)}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText primary="Eliminar Usuario" />
          </ListItem>
        </List>
      </CardContent>
      <CardActions>
        <Button size="medium" onClick={handleCloseMoreOpts} color="inherit" variant="outlined">Cerrar</Button>
      </CardActions>
    </Card>
  );

    const container = window !== undefined ? () => window().document.body : undefined;
    return (
    <Container maxWidth="sm" disableGutters {...swipeHandlers}>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />

      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', pb: 12 }}>
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            px: 2,
            pt: 1.75,
            pb: 1.5,
            backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.95),
            backdropFilter: 'blur(10px)',
            borderBottomLeftRadius: '18px',
            borderBottomRightRadius: '18px',
            overflow: 'hidden',
            boxShadow: (theme) => (theme.palette.mode === 'dark' ? '0 6px 18px rgba(0,0,0,0.35)' : '0 10px 30px rgba(2,21,69,0.08)'),
          }}
        >
          <PageHeader
            title="Gestión de Usuarios"
            icon="user-id"
            onBack={() => navigate(-1)}
            titleSx={{ fontSize: { xs: 18, sm: 22 }, fontWeight: 900 }}
            right={
              <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, px: { xs: 1, sm: 1.25 }, py: 0.4, borderRadius: '999px', bgcolor: (theme) => alpha('#238048', 0.12), flexShrink: 0 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: '999px', bgcolor: '#238048', animation: 'pulseDot 1.8s ease-in-out infinite', '@keyframes pulseDot': { '0%': { opacity: 0.35 }, '50%': { opacity: 1 }, '100%': { opacity: 0.35 } } }} />
                <Typography sx={{ fontSize: 10, fontWeight: 900, letterSpacing: 0.5, color: '#238048', textTransform: 'uppercase' }}>
                  {connectedUsers} en línea
                </Typography>
              </Box>
            }
            sx={{ mb: 2.25 }}
          />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            <Paper
              elevation={0}
              sx={(theme) => ({
                borderRadius: '14px',
                overflow: 'hidden',
                bgcolor: theme.palette.mode === 'dark'
                  ? alpha(theme.palette.common.white, 0.04)
                  : alpha(theme.palette.common.black, 0.02),
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 2px 10px rgba(0,0,0,0.35)'
                  : '0 10px 25px rgba(2,21,69,0.06)',
              })}
            >
              <Box sx={{ position: 'relative' }}>
                <Box sx={{ position: 'absolute', left: 12, top: 0, bottom: 0, display: 'flex', alignItems: 'center', pointerEvents: 'none' }}>
                  <SearchIcon sx={{ color: 'text.secondary' }} />
                </Box>
                <InputBase
                  value={searchValue}
                  onChange={handleSearchChange}
                  placeholder="Buscar por nombre o unidad…"
                  inputProps={{ 'aria-label': 'buscar usuario' }}
                  sx={{
                    width: '100%',
                    pl: 5,
                    pr: 2,
                    py: 1.25,
                    fontSize: 14,
                  }}
                />
              </Box>
            </Paper>

            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                fullWidth
                onClick={(e) => handleTabChange(e, 'activo')}
                sx={(theme) => ({
                  py: 1,
                  borderRadius: '12px',
                  fontSize: 11,
                  fontWeight: 900,
                  letterSpacing: 1,
                  textTransform: 'uppercase',
                  bgcolor: tabValue === 'activo' ? theme.palette.success.main : 'transparent',
                  color: tabValue === 'activo'
                    ? theme.palette.getContrastText(theme.palette.success.main)
                    : (theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary),
                  border: tabValue === 'activo' ? '1px solid transparent' : '1px solid',
                  borderColor: tabValue === 'activo' ? 'transparent' : alpha(theme.palette.divider, 0.8),
                  '&:hover': {
                    bgcolor: tabValue === 'activo'
                      ? theme.palette.success.dark
                      : alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.12 : 0.06),
                  },
                })}
              >
                Activo
              </Button>
              <Button
                fullWidth
                onClick={(e) => handleTabChange(e, 'invitado')}
                sx={(theme) => ({
                  py: 1,
                  borderRadius: '12px',
                  fontSize: 11,
                  fontWeight: 900,
                  letterSpacing: 1,
                  textTransform: 'uppercase',
                  bgcolor: tabValue === 'invitado' ? theme.palette.success.main : 'transparent',
                  color: tabValue === 'invitado'
                    ? theme.palette.getContrastText(theme.palette.success.main)
                    : (theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary),
                  border: tabValue === 'invitado' ? '1px solid transparent' : '1px solid',
                  borderColor: tabValue === 'invitado' ? 'transparent' : alpha(theme.palette.divider, 0.8),
                  '&:hover': {
                    bgcolor: tabValue === 'invitado'
                      ? theme.palette.success.dark
                      : alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.12 : 0.06),
                  },
                })}
              >
                Pendiente
              </Button>
            </Box>
          </Box>
        </Box>

        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Box sx={{ px: 3, pt: 1.75 }}>
          <AnimatePresence initial={false} custom={swipeDirection}>
            <motion.div
              key={tabValue}
              custom={swipeDirection}
              variants={pageVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={pageTransition}
            >
              {!loading && filteredUsers.length === 0 ? (
                <Box sx={{ pt: 8, textAlign: 'center' }}>
                  <PersonOffIcon sx={{ fontSize: 72, color: 'text.secondary', mb: 2 }} />
                  <Typography sx={{ fontSize: 18, fontWeight: 900, color: 'text.primary', mb: 1 }}>
                    {tabValue === 'activo' ? 'No hay usuarios activos' : 'No hay usuarios pendientes'}
                  </Typography>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>
                    {tabValue === 'activo'
                      ? 'Agrega nuevos usuarios usando el botón +.'
                      : 'Luego de agregar usuarios, aparecerán aquí hasta que completen su registro.'}
                  </Typography>
                </Box>
              ) : (
                <Stack spacing={1.25} sx={{ pb: 2 }}>
                  {filteredUsers.map((user) => (
                    <Paper
                      key={user.invcode ? user.invcode : user.username}
                      elevation={0}
                      sx={{
                        p: 2,
                        borderRadius: '16px',
                        bgcolor: (theme) =>
                          theme.palette.mode === 'dark'
                            ? alpha(theme.palette.common.white, 0.04)
                            : alpha(theme.palette.common.black, 0.02),
                        boxShadow: (theme) =>
                          theme.palette.mode === 'dark'
                            ? '0 2px 10px rgba(0,0,0,0.08)'
                            : '0 10px 25px rgba(2,21,69,0.02)',
                        transition: 'transform 120ms ease, box-shadow 120ms ease',
                        '&:hover': {
                          transform: 'translateY(-1px)',
                          boxShadow: (theme) =>
                            theme.palette.mode === 'dark'
                              ? '0 6px 18px rgba(0,0,0,0.12)'
                              : '0 16px 34px rgba(2,21,69,0.04)',
                        },
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar
                          sx={{
                            width: 44,
                            height: 44,
                            bgcolor: (theme) => alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.25 : 0.14),
                            color: (theme) => theme.palette.success.main,
                            fontWeight: 900,
                            flexShrink: 0,
                          }}
                        >
                          {getInitials(user)}
                        </Avatar>

                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 14, fontWeight: 900, color: 'text.primary' }} noWrap>
                            {user?.name} {user?.lastname}
                          </Typography>
                          <Typography sx={{ fontSize: 11, fontWeight: 600, color: 'text.secondary' }} noWrap>
                            {user?.unit || '—'}
                          </Typography>
                          <Box sx={{ mt: 0.5 }}>
                            <Box
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                px: 1,
                                py: 0.25,
                                borderRadius: '6px',
                                fontSize: 10,
                                fontWeight: 900,
                                letterSpacing: 0.5,
                                textTransform: 'uppercase',
                                ...getRoleChipSx(user?.role),
                              }}
                            >
                              {getRoleLabel(user?.role)}
                            </Box>
                            {String(user?.role || '').toLowerCase() === 'admin' && (Array.isArray(user?.team) ? user.team : (user?.team ? [user.team] : [])).filter((t) => !isReservedTeam(t)).map((t) => (
                              <Chip
                                key={t}
                                size="small"
                                label={teamNombre(t)}
                                sx={{
                                  ml: 0.75,
                                  height: 18,
                                  fontSize: 10,
                                  fontWeight: 800,
                                  bgcolor: (theme) => alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.25 : 0.12),
                                  color: (theme) => (theme.palette.mode === 'dark' ? theme.palette.info.main : theme.palette.info.main),
                                  '& .MuiChip-label': { px: 0.75 },
                                }}
                              />
                            ))}
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
                          {tabValue === 'invitado' ? (
                            <>
                              {resendingInvcode === user.invcode && (
                                <CircularProgress size={20} sx={{ color: 'text.secondary' }} />
                              )}
                              <Tooltip title="Compartir">
                                <IconButton onClick={() => shareInvite(user.invcode)} sx={{ color: 'text.secondary' }}>
                                  <ShareIcon />
                                </IconButton>
                              </Tooltip>
                              <IconButton aria-label="Más opciones" onClick={(e) => handlePendingMenuOpen(e, user)} sx={{ color: 'text.secondary' }}>
                                <MoreVertIcon />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <Button
                                size="small"
                                color="secondary"
                                onClick={() => handleEditUser(user.username)}
                                startIcon={<EditIcon />}
                                sx={(theme) => ({
                                  fontWeight: 900,
                                  textTransform: 'none',
                                  ...(theme.palette.mode === 'dark'
                                    ? {
                                        border: '1px solid',
                                        borderColor: alpha(theme.palette.secondary.main, 0.45),
                                        bgcolor: alpha(theme.palette.secondary.main, 0.14),
                                      }
                                    : {}),
                                })}
                              >
                                Editar
                              </Button>
                              <IconButton onClick={() => handleMoreOptions(user)} sx={{ color: 'text.secondary' }}>
                                <MoreVertIcon />
                              </IconButton>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                  {hasMore && (
                    <div ref={sentinelRef} style={{ height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {loadingMore && <CircularProgress size={24} />}
                    </div>
                  )}
                  {!hasMore && filteredUsers.length > 0 && (
                    <Typography sx={{ textAlign: 'center', color: 'text.secondary', fontSize: '0.75rem', py: 2 }}>
                      No hay más usuarios
                    </Typography>
                  )}
                </Stack>
              )}
            </motion.div>
          </AnimatePresence>
        </Box>
      </Box>
      <Dialog open={deleteUserDialog} onClose={closeDeleteUserDialog}>
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea eliminar al usuario {userToDelete ? userToDelete.name : ''} {userToDelete ? userToDelete.lastname : ''}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteUserDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => deleteUser(userToDelete ? userToDelete.user_id : '')} color="secondary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={pwdResetDialog} onClose={closePwdResetDialog}>
        <DialogTitle>Confirmar reinicio de contraseña</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea reiniciar la contraseña del usuario {userToReset ? userToReset.name : ''} {userToReset ? userToReset.lastname : ''}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePwdResetDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => resetPwd(userToReset ? userToReset.username : '')} color="secondary">
            Reiniciar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={accessRestrictModal} onClose={closeAccessRestrictModal}>
        <DialogTitle>Restringir Accesos para {selectedUser ? `${selectedUser.name} ${selectedUser.lastname}` : ''}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Seleccione los módulos a los que desea restringir el acceso:
          </DialogContentText>
          <FormGroup>
            {Object.entries(modules).map(([key, value]) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={selectedModules[key] || false}
                    onChange={handleModuleChange}
                    name={key}
                  />
                }
                label={value}
              />
            ))}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAccessRestrictModal} color="primary">
            Cancelar
          </Button>
          <Button onClick={saveAccessRestrictions} color="secondary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={manageTeamsOpen} onClose={closeManageTeams} fullWidth maxWidth="sm">
        <DialogTitle>Gestionar Equipos</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Crea, renombra o elimina equipos de administradores. Un equipo no puede eliminarse si hay administradores asignados.
          </DialogContentText>

          {teamDeleteError && (
            <Alert severity="error" sx={{ mb: 2, fontSize: 13 }}>{teamDeleteError}</Alert>
          )}

          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'text.primary', mb: 1 }}>
              Equipos existentes
            </Typography>
            {Object.keys(teams).length === 0 ? (
              <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
                No hay equipos creados.
              </Typography>
            ) : (
              <Stack spacing={1}>
                {Object.entries(teams).filter(([key]) => !isReservedTeam(key)).map(([key, t]) => (
                  <Paper
                    key={key}
                    elevation={0}
                    sx={{
                      p: 1.25,
                      borderRadius: '12px',
                      border: '1px solid',
                      borderColor: 'divider',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'text.primary' }} noWrap>
                        {t?.nombre || key}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: 'text.secondary' }} noWrap>
                        {t?.descripcion || 'Sin descripción'}
                      </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => startEditTeam(key, t)} sx={{ color: 'text.secondary' }}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={() => deleteTeam(key)} sx={{ color: 'error.main' }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Paper>
                ))}
              </Stack>
            )}
          </Box>

          <Box sx={{ borderTop: '1px solid', borderColor: (theme) => alpha(theme.palette.divider, 0.5), pt: 2 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'text.primary', mb: 1.5 }}>
              {teamFormKey ? `Editar equipo "${teamFormKey}"` : 'Nuevo equipo'}
            </Typography>
            <Stack spacing={1.5}>
              <TextField
                fullWidth
                size="small"
                label="Nombre"
                value={teamFormNombre}
                onChange={(e) => setTeamFormNombre(e.target.value)}
              />
              <TextField
                fullWidth
                size="small"
                label="Descripción (opcional)"
                value={teamFormDescripcion}
                onChange={(e) => setTeamFormDescripcion(e.target.value)}
                multiline
                rows={2}
              />
              {teamFormError && (
                <Typography sx={{ fontSize: 12, color: 'error.main' }}>{teamFormError}</Typography>
              )}
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button variant="contained" color="secondary" onClick={submitTeamForm} sx={{ textTransform: 'none', fontWeight: 800 }}>
                  {teamFormKey ? 'Guardar cambios' : 'Crear equipo'}
                </Button>
                {teamFormKey && (
                  <Button variant="outlined" color="inherit" onClick={resetTeamForm} sx={{ textTransform: 'none', fontWeight: 800 }}>
                    Cancelar edición
                  </Button>
                )}
              </Box>
            </Stack>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeManageTeams} color="primary">Cerrar</Button>
        </DialogActions>
      </Dialog>
      <Drawer
          container={container}
          anchor="bottom"
          variant="temporary"
          open={drawerShow}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          PaperProps={{ elevation: 0, sx: { backgroundColor: 'background.default' } }}
          sx={{
            display: 'block',
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: '100%',
              maxWidth: '100%',
              height: '100dvh',
              maxHeight: '100dvh',
              borderRadius: 0,
              position: 'fixed',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            },
          }}
        >
          {newUserDrawer}
        </Drawer>
      <Drawer
        container={container}
        anchor="bottom"
        variant="temporary"
        open={moreOptsDrawer}
        onClose={handleCloseMoreOpts}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
        sx={{
          display: 'block',
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: { xs: '100%', sm: 440 },
            left: { xs: 0, sm: '50%' },
            right: 'auto',
            transform: { xs: 'none', sm: 'translateX(-50%)' },
          },
        }}
      >
        {moreOptsDrawerContent}
      </Drawer>
      <Menu
        anchorEl={pendingMenuAnchorEl}
        open={Boolean(pendingMenuAnchorEl)}
        onClose={handlePendingMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handlePendingMenuResend} disabled={Boolean(resendingInvcode) && resendingInvcode === pendingMenuUser?.invcode}>Reenviar</MenuItem>
        <MenuItem onClick={handlePendingMenuDelete} sx={{ color: 'error.main' }}>Eliminar</MenuItem>
      </Menu>
      <Fab
        aria-label="add"
        sx={{
          ...fabStyle,
          backgroundColor: (theme) => (theme.palette.mode === 'dark' ? theme.palette.primary.main : '#021545'),
          color: (theme) => (theme.palette.mode === 'dark' ? theme.palette.getContrastText(theme.palette.primary.main) : 'white'),
          width: 56,
          height: 56,
          minHeight: 0,
          borderRadius: '999px',
          boxShadow: '0 10px 25px rgba(2,21,69,0.25)',
          '&:hover': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? theme.palette.primary.dark : '#021545'),
          },
        }}
        onClick={handleNewUser}
      >
        <AddIcon sx={{ fontSize: 32 }} />
      </Fab>
    </Container>
  );
}